import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  renderTicketReadmoreDetails,
} from "../../utils/common/common";
import { enableAnalytics } from "../../utils/config";
import AnalyticsGraph from "./AnalyticsGraph";

const VideoAnalytics = (props: any) => {
  const { detailRow, pageType } = props;
  const bpdata = detailRow?.bpAnalyticsDetails;
  const [rating, setRating] = useState({});
  const [closeRating, setCloseRating] = useState<any>({});
  const [categoriesValue, setCategoriesValue] = useState<any>([]);

  useEffect(() => {
    handleDefaultResAndRating();
  }, [detailRow]);

  const handleDefaultResAndRating = async () => {
    const fData: number[] = [];
    const lData: number[] = [];
    const sData: number[] = [];
    const categoriesValue: any = [];
    const analyticsData = bpdata && bpdata.length > 0 ? bpdata : [];
    for (const analytics of analyticsData) {
      // const dateTime = analytics["date"].split(" ");
      const dateTime = analytics["date"];
      categoriesValue.push(dateTime);
      // categoriesValue.push([dateTime[1], dateTime[0]]);
      fData.push(Math.round(analytics["freeze_frequency_rating"] * 100) / 100);
      lData.push(Math.round(analytics["layer_rating"] * 100) / 100);
      sData.push(Math.round(analytics["startup_rating"] * 100) / 100);
    }
    setCategoriesValue(categoriesValue);
    const ticketArrival = detailRow?.createdOn;
    let closestTime = categoriesValue[0];
    let diff = Math.abs(ticketArrival - closestTime);
    let closeTimeIndex = 0;
    for (let i = 0; i < categoriesValue.length; i++) {
      const newdiff = Math.abs(ticketArrival - categoriesValue[i]);
      if (newdiff < diff) {
        diff = newdiff;
        closestTime = categoriesValue[i];
        closeTimeIndex = i;
      }
    }
    const closeFreeze = fData[closeTimeIndex];
    const closeStartup = sData[closeTimeIndex];
    const closeLayer = lData[closeTimeIndex];
    const rating = {
      startupRating: sData,
      freezeRating: fData,
      layerRating: lData,
    };
    setRating(rating);
    setCloseRating({
      closeStartup: closeStartup,
      closeFreeze: closeFreeze,
      closeLayer: closeLayer,
    });
  };
  return (
    <Box className="user-reports tickets">
      {bpdata && Object.keys(bpdata).length > 0 && (
        <Accordion defaultExpanded>
          <AccordionSummary
            aria-controls={"panel1-content"}
            id={"panel1-header"}
          >
            <Typography className="title-sm1 accordianTitle">
              video analysis
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {enableAnalytics &&
              (bpdata && bpdata.length > 0 ? (
                <>
                  <AnalyticsGraph
                    detailRow={detailRow}
                    rating={rating}
                    closeRating={closeRating}
                    categoriesValue={categoriesValue}
                  />
                </>
              ) : (
                <Typography className="no-data">No Analytics Data</Typography>
              ))}
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default withSnackbar(VideoAnalytics);
